export default {
  CarouselPlacement__ARIA_LABEL__CURRENT_PAGE: "Current page is ",
  CarouselPlacement__ARIA_LABEL__NEXT: "Next page",
  CarouselPlacement__ARIA_LABEL__PAGE_COUNT: "Total number of pages",
  CarouselPlacement__ARIA_LABEL__PREVIOUS: "Previous page",
};
